var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avg-score"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"score",style:({color: _vm.color})},[_vm._v(_vm._s(_vm.score))])])}
var staticRenderFns = []

export { render, staticRenderFns }